import { render, staticRenderFns } from "./PaymentMethodConfigForm.vue?vue&type=template&id=7f22f976"
import script from "./PaymentMethodConfigForm.vue?vue&type=script&lang=js"
export * from "./PaymentMethodConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports